export default __webpack_public_path__ + "static/angular-e185415c50bc1885eed6c6cc9d2b009e.svg";